var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from 'react';
import { Dialog } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { models } from './model';
import { MTLModel, AmbientLight, DirectionLight } from 'react-3d-viewer';
import './ModalBasicExample.css';
// import './Dialog.Basic.Example.scss';
var DialogBasicExample = /** @class */ (function (_super) {
    __extends(DialogBasicExample, _super);
    function DialogBasicExample(props) {
        var _this = _super.call(this, props) || this;
        _this._showModal = function () {
            _this.setState({ showModal: true });
        };
        _this._closeModal = function () {
            _this.setState({ showModal: false });
        };
        _this.getModel = function () {
            for (var index = 0; index < models.length; index++) {
                var element = models[index];
                if (_this.state.modelName === element.sceneName)
                    return element;
                // return models[0]
            }
        };
        window.handleClickHotspot3DModal = function (name) {
            console.log('modalname==' + name);
            _this.setState(__assign({}, _this.state, { showModal: true, modelName: name, isLoadingModel: true }));
        };
        _this.state = {
            showModal: false,
            modelName: 'scene2-hotspot1',
            isLoadingModel: true
        };
        return _this;
    }
    // componentDidUpdate(){
    //   console.log("testtest");
    //   console.log(document.getElementsByClassName('ms-Dialog-inner'));
    //   console.log(document.getElementsByClassName('ms-Dialog-inner').length>0 && document.getElementsByClassName('ms-Dialog-inner')[0].clientWidth);
    // }
    DialogBasicExample.prototype.getDialogWidth = function () {
        var width = undefined;
        var ele = document.getElementsByClassName('ms-Dialog-inner');
        width = ele.length > 0 ? ele[0].clientWidth - 54 : width;
        console.log(width);
        return width;
    };
    DialogBasicExample.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { id: 'testDialogId' },
            React.createElement(Dialog, { hidden: !this.state.showModal, onDismiss: this._closeModal },
                React.createElement("div", null,
                    this.state.isLoadingModel &&
                        React.createElement(Spinner, { className: 'card-loading-model', size: SpinnerSize.large, label: 'loading...', ariaLive: 'assertive' }),
                    this.getDialogWidth &&
                        React.createElement(MTLModel, { width: this.getDialogWidth() || 200, height: 300, enableZoom: true, position: this.getModel().position, rotation: this.getModel().rotation, mtl: this.getModel().mtl, src: this.getModel().src, texPath: this.getModel().texPath, onLoad: function () {
                                console.log("model loaded");
                                _this.setState(__assign({}, _this.state, { isLoadingModel: false }));
                            } },
                            React.createElement(AmbientLight, { color: 0xffffff }),
                            React.createElement(DirectionLight, { color: 0xffffff, position: { x: 100, y: 200, z: 100 } }),
                            React.createElement(DirectionLight, { color: 0xffffff, position: { x: -100, y: 200, z: -100 } }))),
                React.createElement("div", { className: 'card-custom-footer' },
                    React.createElement("span", { className: 'card-instructions' }, !(window.matchMedia && window.matchMedia("(max-width: 480px)").matches) ? "use mouse wheel to zoom in or out, move the mouse with left click to rotate the item" :
                        "pinch to zoom in or out, hold touch and move finger to rotate the item"),
                    React.createElement("span", { className: 'card-title' }, this.getModel().title),
                    React.createElement("p", { className: 'card-sub-title' }, this.getModel().description),
                    React.createElement("span", { className: 'card-add-to-cart-button' },
                        React.createElement(DefaultButton, { primary: true, "data-automation-id": 'test', disabled: false, checked: true, text: 'Add To Cart', onClick: function () { return alert("Add to cart demo"); } }))))));
    };
    return DialogBasicExample;
}(React.Component));
export { DialogBasicExample };



//////////////////
// WEBPACK FOOTER
// ./src/DialogBasicExample.tsx
// module id = 241
// module chunks = 0